import React from 'react';
import HeroSection from './HeroSection';
import Stats from './Stats';
import Journey from './Journey';

const Home = () => {
    return (
        <>
            <HeroSection />
            <Stats />
            <Journey />
        </>
    );
};

export default Home;
